import { render, type ComponentChild } from "preact";

/**
 * Render a Preact component into a DOM container by ID.
 * Use this to mount Preact "islands" into server-rendered pages
 * without affecting the rest of the page.
 */
export function renderIsland(containerId: string, vnode: ComponentChild): void {
  const container = document.getElementById(containerId);
  if (container) {
    render(vnode, container);
  }
}
